import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import type { Route as AppRoute } from '@api/app_context/types';

import { getFirstAvailableRoute, getRouteComponent } from './utilities/helpers';

const LEGACY_CANVAS_PATH = 'narratives';

/**
 * redirects the legacy canvas URL to the canvas route supplied by app context,
 * forwarding the query string the canvas reads on mount (sessionId, narrativeId)
 */
const LegacyCanvasRedirect = ({ to }: { to: string }) => {
  const { search, state } = useLocation();

  return <Navigate replace state={state} to={`${to}${search}`} />;
};

export const Router = () => {
  const { routes: userRoutes } = useSelector((state: any) => state?.user?.data);
  const nexaCanvasRoute = userRoutes?.find(
    (route: AppRoute) => !route.is_locked && route.id === 'nexa'
  );
  // top level only, so the nested My Workspace list route never claims the legacy path
  const hasLegacyCanvasRoute = userRoutes?.some(
    (route: AppRoute) => !route.is_locked && route.path === LEGACY_CANVAS_PATH
  );

  const renderRoutes = ({ routes }: { routes: AppRoute[] }) => {
    return routes
      .filter(({ is_locked }) => !is_locked)
      .map((route) => {
        const routeCatchChildren =
          route.routes?.length || ['instant-surveys'].includes(route.id) ? '/*' : '';

        return (
          <Route
            element={getRouteComponent(route)}
            key={route.id}
            path={`${route.path}${routeCatchChildren}`}
          />
        );
      });
  };

  return (
    <Routes>
      {renderRoutes({ routes: userRoutes })}
      {nexaCanvasRoute && !hasLegacyCanvasRoute && (
        <Route
          element={<LegacyCanvasRedirect to={`/dashboard/${nexaCanvasRoute.path}`} />}
          path={LEGACY_CANVAS_PATH}
        />
      )}
      <Route element={<Navigate replace to={getFirstAvailableRoute(userRoutes)} />} path="*" />
    </Routes>
  );
};

export default Router;
